import store from '@/store'

let debounce = null
const DEBOUNCE_TIMEOUT = 100

export const dispatch = response => {
  if (response?.message?.data?.type) {
    if (debounce) {
      clearTimeout(debounce)
    }

    debounce = setTimeout(() => {
      const { type, items } = response.message.data
      socketMessages[type] ? socketMessages[type](items) : socketMessages['default'](response)
    }, DEBOUNCE_TIMEOUT)
  } else if (response.type === 'confirm_subscription') {
    store.dispatch('loadingCable', false)
  }
}

const socketMessages = {

  'on_students_authorization' (items) {
    store.dispatch(
      'authorizationInfos/onStudentsReceived',
      items
    )
  },

  'default' (message) {
    console.log('ON_SOCKET_MESSAGE: Unknow message type', message)
  }
}
